import { Connection, DatabaseProvider } from "src/api/connectApi/types";
import { BigQuerySQLConnectionConfigForm } from "src/connections/config/database/bigquery/BigQuerySQLConnectionConfigForm";
import { CockroachDBConnectionConfigForm } from "src/connections/config/database/cockroach/CockroachDBConnectionConfigForm";
import { MongoDBConnectionConfigForm } from "src/connections/config/database/mongodb/MongoDBConnectionConfigForm";
import { MySQLConnectionConfigForm } from "src/connections/config/database/mysql/MySQLConnectionConfigForm";
import { PostgreSQLConnectionConfigForm } from "src/connections/config/database/postgresql/PostgreSQLConnectionConfigForm";
import { RedshiftConnectionConfigForm } from "src/connections/config/database/redshift/RedshiftConnectionConfigForm";
import { SnowflakeConnectionConfigForm } from "src/connections/config/database/snowflake/SnowflakeConnectionConfigForm";

type Props = {
  provider: DatabaseProvider;
  onClose: () => void;
  workspaceUrl: string;
  connection?: Connection;
};

const DB_CONNECTION_CONFIG_FORMS = {
  postgresql: PostgreSQLConnectionConfigForm,
  cockroachdb: CockroachDBConnectionConfigForm,
  bigquery: BigQuerySQLConnectionConfigForm,
  snowflake: SnowflakeConnectionConfigForm,
  redshift: RedshiftConnectionConfigForm,
  mysql: MySQLConnectionConfigForm,
  mongodb: MongoDBConnectionConfigForm,
};

export const SQLDatabaseConnectionConfigForm: React.FC<Props> = ({
  provider,
  onClose,
  workspaceUrl,
  connection,
}) => {
  const ConnectionConfigForm = DB_CONNECTION_CONFIG_FORMS[provider];
  return (
    <ConnectionConfigForm
      connection={connection}
      workspaceUrl={workspaceUrl}
      onClose={onClose}
    />
  );
};
